(function(sb) {
	"use strict";

	sb.MyStories = (sb.MyStories || {});

	var isLoaded = false;

	var myStoriesList;
	var myStorySlides;
	var slideInfoWindow;
	var sessionStorageKey = 'DUIMyStories';
	var myStoriesSlideTooltip;
	var groupsForSharingLoaded = false;

	var exportStatus = {
		Unknown: 0,
		Completed: 1,
		Queued: 2,
		Running: 3,
		Failed: 4
	};

	var STORE = {
		stories: []
	};

	STORE.getSelectedStory = function getSelectedStory() {
		var story = $('.mystories-list-item.selected', myStoriesList).data('story');
		return story ? story.data : null;
	};

	STORE.getSelectedSlides = function getSelectedSlides() {
		return $('.mystories-slide.ui-selected', myStorySlides).map(function(index, slideEl) {
			var slide = $(slideEl).data('slide');
			return slide ? slide.data : null;
		}).toArray();
	};

	STORE.addStory = function addStory(storyToAdd) {
		STORE.stories = STORE.stories.concat(storyToAdd);
	};

	STORE.deleteStory = function deleteStory(storyToDelete) {
		STORE.stories = STORE.stories.filter(function(story) {
			return story.storyId !== storyToDelete.storyId;
		});
	};

	STORE.addSlide = function addSlide(story, slideToAdd) {
		story.slides = story.slides.concat(slideToAdd);
	};

	STORE.removeSlide = function removeSlide(slideToDelete) {
		var selectedStory = STORE.getSelectedStory();
		selectedStory.slides = selectedStory.slides.filter(function(slide) {
			return slide.slideId !== slideToDelete.slideId;
		});
	};

	STORE.updateMyStorySize = function updateMyStorySize(story) {
		var currentStoryboardSlide = Storyboard.LayoutDesigner.getCurrentSlide();
		if (story.slides.length === 0) {
			delete story.width;
			delete story.height;
		} else if (story.slides.length === 1 && currentStoryboardSlide) {
			story.width = currentStoryboardSlide.width;
			story.height = currentStoryboardSlide.height;
		}
	};

	STORE.getNewSortOrderIndex = function getNewSortOrderIndex(arr) {
		return arr.reduce(function(sortOrder, obj) {
			if (obj.sortOrder > sortOrder) return obj.sortOrder;
			return sortOrder;
		}, 0) + 1;
	};

	STORE.updateSortOrder = function updateSortOrder(arr) {
		arr.sort(STORE.compareSortOrder)
			.forEach(function(obj, index) {
				obj.sortOrder = index + 1;
			});
	};

	STORE.compareSortOrder = function compareSortOrder(a, b) {
		return a.sortOrder - b.sortOrder;
	};

	var getSessionStorage = function() {
		return JSON.parse(window.sessionStorage.getItem(sessionStorageKey)) || {};
	}

	var setSessionStorage = function(sessionData) {
		window.sessionStorage.setItem(sessionStorageKey, JSON.stringify(sessionData));
	}

	//
	// My Story
	//
	var Story = {

		init: function(data) {
			this.data = data;

			this.$elem = $(this._build());
			this.elem = this.$elem.get(0);

			$.data(this.elem, 'story', this);

			return this;
		},

		_build: function() {
			return '<div class="mystories-list-item" tabindex="0" data-story-id="' + this.data.storyId + '">' +
				this._renderSortHanlder() +
				this._renderName() +
				'</div>';
		},

		_renderSortHanlder: function() {
			return '<div class="sort-handle"><i class="DUI-icon DUI-icon-drag"></i></div>';
		},

		_renderBackIcon: function() {
			return '<div class="back-to-stories-handle"><i class="DUI-icon DUI-icon-a-left"></i></div>';
		},

		_renderName: function() {
			return '<span class="mystories-list-item-name">' + HTMLHelpers.htmlEncode(this.data.name) + '</span>';
		},

		_renderRenameInput: function() {
			return '<input type="text" id="txtMyStoryRename" class="mystory-rename fullInput" value="' + this.data.name + '" />';
		},

		_destroy: function() {
			this.$elem.remove();
		},

		showButtons: function() {
			var buttonsHtml =
				"<div class='mystories-menu'>" +
				"<button type='button' class='mystory-add-slide DUIButtonIcon' data-tooltip='" + locale.get("Add current slide", 4) + "' data-position='left'>" +
				"<i class='DUI-icon DUI-icon-add'></i>" +
				"</button>" +
				"<button type='button' class='mystory-export DUIButtonIcon' data-tooltip='" + locale.get("Export", 4) + "' data-position='left'>" +
				"<i class='DUI-icon DUI-icon-export'></i>" +
				"</button>" +
				"<div class='mystory-more DUIButtonIcon'>" +
				"<i class='DUI-icon DUI-icon-more'></i>" +
				"<ul class='mystories-sub-menu DUIContextMenu'>" +
				"<li class='mystory-update-thumbnails'><span><em>" +
				locale.get("Update thumbnails", 4) +
				"<i class='DUI-icon DUI-icon-loop'></i>" +
				"</em></span></li>" +
				"<li class='mystory-rename'><span><em>" +
				locale.get("Rename story", 4) +
				"<i class='DUI-icon DUI-icon-edit'></i>" +

				"</em></span></li>" +
				"<li class='mystory-delete'><span><em>" +
				locale.get("Delete story", 4) +
				"<i class='DUI-icon DUI-icon-trash'></i>" +
				"</em></span></li>" +
				"</ul>" +
				"</div>" +
				"</div>";

			$(".mystories-menu", myStoriesList).remove();
			this.$elem.append(buttonsHtml);

			if (!this.data.slides || this.data.slides.length < 1)
				this.$elem.find(".mystory-export").hide();
			else
				this.$elem.find(".mystory-export").show();

			this.$elem.find(".mystory-add-slide").css('display', 'none');
		},

		hideButtons: function() {
			$(".mystories-menu", this.$elem).remove();
		},

		select: function() {
			this.$elem.addClass('selected').focus();
			this.$elem.html(this._renderBackIcon() + this._renderName());

			this.showButtons();
			this.$elem.find(".mystory-add-slide").css('display', '');

			setSessionStorage({ open: true, selectedStoryId: this.data.storyId });

			UI.renderStorySlides(this.data);
		},

		updateThumbnails: function(reload) {
			this.data.slides.forEach(function(slide) {
				slide.isLoadingThumbnail = true;
			});

			if (!reload)
				UI.renderStorySlides(this.data);
			else
				MyStoriesProxy.updateStoryThumbnails(this.data.storyId, function() {
					UI.reloadSlideThumbnails(true);
				});
		},

		export: function() {
			var story = this;

			if ($("#myStoriesPanel .downloadcontainer").length > 0 && $("#hidStoryIdToExport").val() == story.data.storyId) // this story's export panel is open - close
				$("#close_downloadSelectedPowerpoint").click();
			else {
				if ($(".downloadChart .downloadcontainer:visible").length > 0) // storyteller export panel is open - close
					$("#close_downloadSelectedPowerpoint").click();

				// fetch settings and show panel
				MyStoriesProxy.getStoryExportSettings(story.data.storyId, function(storySettings) {
					Storyboard.LayoutDesigner.downloadSelected(storySettings);

					$('.downloadcontainer').after('<div class="downloadplaceholder"></div>');
					$('.downloadcontainer').appendTo('#myStoriesPanel');

					$("#close_downloadSelectedPowerpoint").bind('click', function() {
						if ($(".downloadChart .downloadplaceholder").length > 0)
							$('.downloadplaceholder').replaceWith($('.downloadcontainer'));
					});
				});
			}
		},

		rename: function() {
			var story = this;
			var name = story.data.name;

			this.$elem
				.addClass('mystory-renaming')
				.html(this._renderRenameInput());

			function endRename() {
				story.$elem.removeClass('mystory-renaming');

				if (story.$elem.hasClass('selected'))
					story.$elem.html(story._renderBackIcon() + story._renderName());
				else
					story.$elem.html(story._renderSortHanlder() + story._renderName());

				story.showButtons();
			}

			$("#txtMyStoryRename")
				.focus().select()
				.bind("click", function() { return false; })
				.bind('blur', function() {
					var newName = this.value.trim();
					var xssRegex = new RegExp("^[^<>=]+$");

					if (newName.length === 0 || newName === name) {
						endRename();
					} else if (!xssRegex.test(newName)) {
						endRename();
						DUImessage.show("Story name contains invalid characters <>=", "Message-error", 5000);
					} else {
						MyStoriesProxy.renameStory(story.data, newName, function() {
							story.data.name = newName;
							UI.showHideTools();
							endRename();
						});
					}

				}).bind("keypress", function(event) {
					if (event.keyCode === 13) {
						event.preventDefault();
						this.blur();
					} else if (event.keyCode === 27) {
						endRename();
					}
				});
		},

		delete: function() {
			var story = this;
			var warningText = locale.get("Do you really want to delete #STORY_NAME#?", 4).replace("#STORY_NAME#", "<b>" + HTMLHelpers.htmlEncode(story.data.name) + "</b>");
			new DUIwindow2({
				width: 420,
				html: '<p>' + warningText + '</p>',
				closeButton: false,
				buttons: [
					{
						text:
							locale.get("Cancel", 4),
						cssClass: 'DUIButton',
						closeWindow: true
					},
					{
						text: locale.get("Delete", 4), cssClass: 'DUIButton', focused: true, onClick: function() {
							MyStoriesProxy.deleteStory(story.data, function() {
								story._destroy();
								STORE.deleteStory(story.data);
								STORE.updateSortOrder(STORE.stories);
								UI.renderStoriesList();
								UI.showHideTools();
								DUImessage.show(locale.get("#STORY_NAME# deleted successfully", 4).replace("#STORY_NAME#", HTMLHelpers.htmlEncode(story.data.name)), 'Message-success', 5000);
							});
						}
					}
				]
			});
		}
	};


	//
	// My Story Slide
	//
	var Slide = {

		init: function(data) {
			this.data = data;

			this.$elem = $(this._build());
			this.elem = this.$elem.get(0);

			$.data(this.elem, 'slide', this);

			return this;
		},

		_build: function() {
			return '<div class="mystories-slide" tabindex="0" data-id="' + this.data.slideId + '">' +
				'<span class="sort-handle"><i class="DUI-icon DUI-icon-drag"></i></span>' +
				'<div class="mystories-slide-thumb">' +
				this._renderThumbnail() +
				'</div>' +
				this._renderName() +
				'</div>';
		},

		_renderName: function() {
			return '<div class="mystories-slide-name" title="' + this.data.name + '">' +
				'<span class="mystories-slide-sort-order">' + this.data.sortOrder + '</span>' +
				'<span>' + HTMLHelpers.htmlEncode(this.data.name) + '</span>' +
				'</div>';
		},

		_renderRenameInput: function() {
			return '<input type="text" id="txtMyStoriesSlideRename" class="mystories-slide-rename fullInput" value="' + this.data.name + '" />';
		},

		_renderThumbnail: function() {
			if (this.data.isLoadingThumbnail)
				return '<div class="mystory-slide-loading">' +
					'<img class="mystory-slide-loading-img" src="../images/spinner.gif" />' +
					'<div class="mystory-slide-text">' + locale.get("Generating thumbnail", 4) + '</div>' +
					'</div>';

			return '<img src="' + this.getImgUrl() + '" style="visibility: hidden" />'; //&width=x&height=y
		},

		_destroy: function() {
			this.$elem.remove();
		},

		getImgUrl: function() {
			return "FileHandler.ashx?storySlideThumbnail=true&stId=" + this.data.storyId + "&slId=" + this.data.slideId;
		},

		getSlideInfoHtml: function() {
			var infoHTML = '';
			var originalReportName = (this.data.sourceReportName ? "<tr><th>" + locale.get("Report name:", 4) + "</th><td>" + HTMLHelpers.htmlEncode(this.data.sourceReportName) + "</td></tr>" : "");
			var originalSlideIndex = this.data.chartCreatorSlide ? "" : (this.data.sourceSlideIndex ? "<tr><th>" + locale.get("Slide index:", 4) + "</th><td>" + this.data.sourceSlideIndex + "</td></tr>" : "");
			var optionalFilters = this.data.chartCreatorSlide ? "" : (this.data.settingsText ? "<tr><th>" + locale.get("Optional filters:", 4) + "</th><td>" + this.data.settingsText + "</td></tr>" : "");

			infoHTML += '<div class="mystory-slide-info cf">';
			infoHTML += '<div class="size-1-2">';
			infoHTML += '<img id="myStorySlideInfoScreenshot" class="mystory-slide-screenshot-loading" src="../images/spinner.gif" />';
			infoHTML += '</div>';
			infoHTML += '<div class="mystory-slide-info-content size-1-2">' +
				'<table class="mystory-slide-info-table">' +
				originalReportName +
				originalSlideIndex +
				optionalFilters +
				'</table>';
			infoHTML += '<div class="mystory-slide-info-buttons">' +
				'<button type="button" class="DUIButtonGray mystory-slide-info-go">' + locale.get("Go to slide", 4) + '</button>' +
				'<button type="button" class="DUIButtonGray mystory-slide-info-remove">' + locale.get("Remove slide", 4) + '</button>' +
				'</div>';
			infoHTML += '</div>';
			infoHTML += '</div>';

			return infoHTML;
		},

		showButtons: function() {
			var buttonsHtml = '<div class="mystories-slide-menu">' +
				'<button type="button" class="mystory-slide-info DUIButtonIcon" data-tooltip="' + locale.get("Info", 4) + '" data-position="bottom">' +
				'<i class="DUI-icon DUI-icon--c DUI-icon-info"></i>' +
				'</button>' +
				'<button type="button" class="mystory-goto-slide DUIButtonIcon" data-tooltip="' + locale.get("Go to slide", 4) + '" data-position="bottom">' +
				'<i class="DUI-icon DUI-icon--c DUI-icon-shortcuts"></i>' +
				'</button>' +
				'<button type="button" class="mystory-slide-rename DUIButtonIcon" data-tooltip="' + locale.get("Rename slide", 4) + '" data-position="bottom">' +
				'<i class="DUI-icon DUI-icon--c DUI-icon-edit"></i>' +
				'</button>' +
				'<button type="button" class="mystory-slide-remove DUIButtonIcon" data-tooltip="' + locale.get("Remove slide", 4) + '" data-position="bottom">' +
				'<i class="DUI-icon DUI-icon--c DUI-icon-trash"></i>' +
				'</button>' +
				'</div>';

			this.$elem.append(buttonsHtml);
		},

		showTooltip: function() {
			var slide = this;
			var data = this.data;

			if (data.settingsText == null && !data.chartCreatorSlide) {
				MyStoriesProxy.getSlideSettingsText(data, function(text) {
					data.settingsText = text;
					slide.showTooltip();
				});
				return;
			}

			var originalReportName = (data.sourceReportName ? "<i>" + locale.get("Report name:", 4) + "</i> <span>" + HTMLHelpers.htmlEncode(data.sourceReportName) + "</span><br>" : "");
			var originalSlideIndex = data.chartCreatorSlide ? "" : (data.sourceSlideIndex ? "<i>" + locale.get("Slide index:", 4) + "</i> <span>" + data.sourceSlideIndex + "</span><br>" : "");
			var optionalFilters = data.chartCreatorSlide ? "" : (data.settingsText ? "<p><i>" + locale.get("Optional filters:", 4) + "</i><br><span>" + data.settingsText + "</span></p>" : "");
			var infoHTML = originalReportName + originalSlideIndex + optionalFilters;

			var tooltipHtml =
				'<div class="DUITooltipInfo myStoriesSlideTooltip">' + infoHTML + '</div>';

			if (myStoriesSlideTooltip)
				myStoriesSlideTooltip.destroy();

			$('body > .myStoriesSlideTooltip').remove();

			if (infoHTML.length > 0) {
				$('body').append(tooltipHtml);

				myStoriesSlideTooltip = new Tether({
					element: $('body .myStoriesSlideTooltip').get(0),
					target: this.elem,
					attachment: 'bottom center',
					targetAttachment: 'top center',
					offset: '15px 0',
					addTargetClasses: false,
					constraints: [{
						to: 'scrollParent',
						attachment: 'together'
					}]
				});
			}
		},

		hideTooltip: function() {
			if (myStoriesSlideTooltip) {
				myStoriesSlideTooltip.destroy();
				$(myStoriesSlideTooltip.element).remove();
			}
		},

		hideButtons: function() {
			this.$elem.find('.mystories-slide-menu').remove();
		},

		goToSlide: function() {
			var slideUrl = window.location.href.replace("RpId=" + Helpers.getReportID(),
				"RpId=" + encodeURIComponent(this.data.sourceReportId));

			if (slideUrl.indexOf("&slide=") > 0)
				slideUrl = slideUrl.replace("&slide=" + Helpers.getURLParameter("slide"), "&slide=" + encodeURIComponent(this.data.sourceSlideIndex));
			else
				slideUrl += "&slide=" + encodeURIComponent(this.data.sourceSlideIndex);

			if (slideUrl.indexOf("&mssId=") > 0)
				slideUrl = slideUrl.replace("&mssId=" + Helpers.getURLParameter("mssId"), "&mssId=" + encodeURIComponent(this.data.storyId) + "-" + encodeURIComponent(this.data.slideId));
			else
				slideUrl += "&mssId=" + encodeURIComponent(this.data.storyId) + "-" + encodeURIComponent(this.data.slideId);

			window.location.assign(slideUrl);
		},

		rename: function() {
			var slide = this;
			var name = slide.data.name;

			this.$elem.find('.mystories-slide-name').remove();
			this.$elem.append(this._renderRenameInput());

			function endRename() {
				slide.$elem.find('#txtMyStoriesSlideRename').remove();
				slide.$elem.append(slide._renderName());
			}

			$("#txtMyStoriesSlideRename")
				.focus().select()
				.bind("click", function() { return false; })
				.bind('blur', function() {
					var newName = this.value.trim();
					var xssRegex = new RegExp("^[^<>=]+$");

					if (newName.length === 0 || newName === name) {
						endRename();
					} else if (!xssRegex.test(newName)) {
						endRename();
						DUImessage.show("Slide name contains invalid characters <>=", "Message-error", 5000);
					} else {
						MyStoriesProxy.renameSlide(slide.data, newName, function() {
							slide.data.name = newName;
							UI.showHideTools();
							endRename();
						});
					}

				}).bind("keypress", function(event) {
					if (event.keyCode === 13) {
						event.preventDefault();
						this.blur();
					} else if (event.keyCode === 27) {
						endRename();
					}
				});
		},

		remove: function() {
			var selectedStory = STORE.getSelectedStory();
			var selectedSlides = STORE.getSelectedSlides();
			var message = '';

			if (selectedSlides.length === 0)
				selectedSlides = [this.data];

			if (selectedSlides.length === 1) {
				message = '<p>' + locale.get('Do you really want to remove #SLIDE_NAME#?', 4).replace("#SLIDE_NAME#", "<b>" + HTMLHelpers.htmlEncode(selectedSlides[0].name) + "</b>") + '</p>';
			} else {
				message = '<p>' + locale.get('Do you really want to remove slides from My Stories') + '?</p>';
				message += '<p>' + selectedSlides.map(function(slide) {
					return '<b>' + HTMLHelpers.htmlEncode(slide.name) + '</b><br>';
				}).join('') + '</p>';
			}

			new DUIwindow2({
				width: 420,
				html: message,
				closeButton: false,
				buttons: [{
					text:
						locale.get("Cancel", 4),
					cssClass: 'DUIButton',
					closeWindow: true
				}, {
					text: locale.get("Remove", 4),
					cssClass: 'DUIButton',
					focused: true,
					onClick: function() {
						MyStoriesProxy.removeSlides(selectedStory.storyId, selectedSlides, function() {
							if (slideInfoWindow)
								UI.navigateSlideInfo();

							selectedSlides.forEach(STORE.removeSlide);

							STORE.updateMyStorySize(selectedStory);
							STORE.updateSortOrder(selectedStory.slides);
							UI.renderStorySlides(selectedStory);
							UI.showHideTools();

							if (selectedSlides.length === 1) {
								DUImessage.show(locale.get("#SLIDE_NAME# removed from MyStories successfully", 4).replace("#SLIDE_NAME#", HTMLHelpers.htmlEncode(selectedSlides[0].name)), 'Message-success', 5000);
							} else {
								DUImessage.show(selectedSlides.length + ' ' + locale.get('slides removed from MyStories successfully'), 'Message-success', 5000);
							}
						});
					}
				}]
			});
		}
	};


	//
	// UI
	//
	var UI = (function() {

		function renderStoriesList() {
			var elements = [];

			STORE.stories
				.sort(STORE.compareSortOrder)
				.forEach(function(storyData) {
					var newStory = Object.create(Story).init(storyData);
					elements.push(newStory.elem);
				});

			myStoriesList.html(elements);
			myStoriesList.parent().removeClass('mystories-open-story');
			myStorySlides.hide();

			UI.search();
			UI.showHideTools();
		}

		function renderStorySlides(story) {
			var elements = [];
			var selectedSlides = STORE.getSelectedSlides();

			story.slides
				.sort(STORE.compareSortOrder)
				.forEach(function(slideData) {
					var newSlide = Object.create(Slide).init(slideData);
					elements.push(newSlide.elem);
				});

			if (!story.slides || story.slides.length < 1)
				myStoriesList.parent().find(".mystory-export").hide();
			else
				myStoriesList.parent().find(".mystory-export").show()

			myStorySlides.html(elements);
			myStorySlides.show();
			myStoriesList.parent().addClass('mystories-open-story');

			if (selectedSlides)
				UI.selectSlide(selectedSlides);

			UI.search();
			UI.showHideTools();
			UI.reloadSlideThumbnails();
			UI.renderAddSlideButtons();
			UI.setSlidesContainerHeight();
			UI.renderRowsSeparators();
		}

		function backToStories() {
			UI.clearSearch();
			UI.renderStoriesList();
			setSessionStorage({ open: true });
		}

		function renderRowsSeparators() {
			var columns = Math.floor(myStorySlides.width() / (220 + 40));

			$('.separator', myStorySlides).remove();

			if (columns > 1)
				$('> .mystories-slide-add, > .mystories-slide:visible', myStorySlides)
					.filter(function(index) {
						return (index + 1) % columns === 0;
					})
					.each(function() {
						$(this).after('<div class="separator" style="clear: both;"></div>');
					});
		}

		function setSlidesContainerHeight() {
			var myStoriesPanel = $('#myStoriesPanel');
			var containerPop = myStorySlides.parent().get(0).getBoundingClientRect().top;
			var containerPadding = parseInt(myStorySlides.parent().css('padding-top')) || 0;
			var height = myStoriesPanel.height() - containerPop - containerPadding;
			myStorySlides.parent().css('height', height);
		}

		function reloadSlideThumbnails(force) {
			var selectedStory = STORE.getSelectedStory();

			function reloadThumbnail(slideData) {
				MyStoriesProxy.getSlideThumbnailState(slideData.slideId, function(slideId, status) {
					var slide = $('.mystories-slide[data-id="' + slideData.slideId + '"]', myStorySlides).data('slide');

					if (slide) {
						if (status === exportStatus.Running || status === exportStatus.Queued) {
							slideData.isLoadingThumbnail = true;
							slide.$elem.find('.mystories-slide-thumb').html(slide._renderThumbnail());
							setTimeout(function() { reloadThumbnail(slideData); }, 3000);
							return;
						}

						if (status === exportStatus.Completed) {
							delete slide.data.isLoadingThumbnail;
							var thumbnailEl = $(slide._renderThumbnail());
							thumbnailEl.attr('src', thumbnailEl.attr('src') + '&v=' + Date.now());
							slide.$elem.find('.mystories-slide-thumb').html(thumbnailEl);
							slide.$elem.find('.mystories-slide-thumb > img').css('visibility', '');
							if ($('#myStorySlideInfoScreenshot').length === 1 && slide.$elem.hasClass('ui-selected'))
								loadSlideImage(slide.getImgUrl() + '&v=' + Date.now());
						} else if (status === exportStatus.Unknown || status === exportStatus.Failed) {
							delete slide.data.isLoadingThumbnail;
							slide.$elem.find('.mystories-slide-thumb').empty();
						}
					}
				});
			}

			selectedStory.slides
				.forEach(function(slide) {
					$('.mystories-slide[data-id="' + slide.slideId + '"] .mystories-slide-thumb > img', myStorySlides)
						.bind('error', function() { reloadThumbnail(slide); })
						.bind('load', function() { $(this).css('visibility', ''); });
					if (slide.isLoadingThumbnail || force)
						reloadThumbnail(slide);
				});
		}

		function renderAddSlideButtons() {
			var selectedStory = STORE.getSelectedStory();

			var addSlideButton = '<button type="button" div class="mystories-slide-add">' +
				'<div class="mystories-slide-add-content">' +
				'<i class="DUI-icon DUI-icon-c-plus mystories-slide-add-icon"></i>' +
				'<div class="mystories-slide-add-text">' + locale.get("Add current slide", 4) + '</div>' +
				'</div>' +
				'</button>';

			if (selectedStory.slides.length === 0) {
				myStorySlides.html(addSlideButton);
			} else {
				myStorySlides.append(addSlideButton);
				myStorySlides.prepend(addSlideButton);
			}
		}

		function addResizableToMyStoriesPanel() {
			$("#myStoriesPanel").resizable({
				minWidth: 235,
				handles: 'w',
				stop: function() {
					$(this).css({ left: '' });
					UI.setSlidesContainerHeight();
					UI.renderRowsSeparators();
				}
			});
		}

		function addSortableToStories() {
			myStoriesList.sortable({
				items: '> .mystories-list-item',
				handle: '.sort-handle',
				tolerance: 'pointer',
				helper: 'clone',
				delay: 100,
				start: function(event, ui) {
					$(this).addClass('ui-sorting');
					myStoriesList.sortable('refreshPositions');
				},
				stop: function(event, ui) {
					$(this).removeClass('ui-sorting');
				},
				update: function(event, ui) {
					var order = myStoriesList.sortable('toArray', { attribute: 'data-story-id' });

					MyStoriesProxy.saveStoriesOrder(order, function() {
						STORE.stories.forEach(function(story) {
							story.sortOrder = Number(order.indexOf(String(story.storyId)));
						});

						STORE.updateSortOrder(STORE.stories);
						UI.renderStoriesList();
						UI.showHideTools();
					});
				}
			});
		}

		function addSelectableToSlides() {
			myStorySlides.delegate('.mystories-slide', 'click', function(event) {
				var selected = $(this).hasClass('ui-selected');
				var newSlide = $(this).hasClass('mystories-new-slide');

				if (!newSlide) {
					if (!event.ctrlKey && !event.metaKey) {
						myStorySlides.find('.ui-selected').removeClass('ui-selected');
						if (!selected)
							$(this).addClass('ui-selected');
					} else {
						$(this).addClass('ui-selected');
					}

					$(this).focus();
				}
			});
		}

		function addSortableToSlides() {
			myStorySlides.sortable({
				items: '> .mystories-slide',
				cancel: '.mystories-new-slide',
				tolerance: 'pointer',
				delay: 100,
				helper: function(event, item) {
					if (!item.hasClass('ui-selected')) {
						item.parent().children('.ui-selected').removeClass('ui-selected');
						item.addClass('ui-selected');
					}

					var selected = item.parent().children('.ui-selected').clone();
					item.data('multidrag', selected).siblings('.ui-selected').remove();
					return $('<div/>').append(selected);
				},
				start: function(event, ui) {
					myStorySlides.sortable('option', 'cursorAt', {
						left: event.offsetX,
						top: event.offsetY
					});

					myStorySlides.sortable('refreshPositions');
				},
				stop: function(e, ui) {
					var selected = ui.item.data('multidrag');
					if (selected) {
						var selectedStory = STORE.getSelectedStory();
						UI.renderStorySlides(selectedStory);
					}
				},
				change: function() {
					UI.renderRowsSeparators();
				},
				update: function(event, ui) {
					var selectedStory = STORE.getSelectedStory();
					var selected = ui.item.data('multidrag');

					if (selected) {
						ui.item.after(selected);
						ui.item.remove();
					}

					var order = myStorySlides.sortable('toArray', { attribute: 'data-id' });

					MyStoriesProxy.saveSlidesOrder(order, function() {
						selectedStory.slides.forEach(function(slide, index, slidesArray) {
							slide.sortOrder = Number(order.indexOf(String(slide.slideId)));
						});

						STORE.updateSortOrder(selectedStory.slides);
						UI.renderStorySlides(selectedStory);
						UI.showHideTools();
					});
				}
			});
		}

		function newStory() {
			var newStory = {
				name: '',
				sortOrder: STORE.getNewSortOrderIndex(STORE.stories),
				slides: []
			};

			var newStoryInput =
				'<div class="mystories-list-item mystories-new-list-item" data-story-id="' + newStory.storyId + '">' +
				'<input type="text" id="txtNewMyStoryName" class="new-mystory-name fullInput" placeholder="' + locale.get("Name of new story", 4) + '" />' +
				'</div>';

			UI.deselectStories();
			myStoriesList.append(newStoryInput);

			$("#txtNewMyStoryName")
				.focus()
				.bind('click', function() { return false; })
				.bind('blur', function() {
					var newMyStoryName = this.value.trim();
					var xssRegex = new RegExp("^[^<>=]+$");

					if (newMyStoryName.length === 0) {
						$('.mystories-new-list-item', myStoriesList).remove();
					}
					else if (!xssRegex.test(newMyStoryName)) {
						$('.mystories-new-list-item', myStoriesList).remove();
						DUImessage.show("Story name contains invalid characters <>=", "Message-error", 5000);
					}
					else {
						newStory.name = newMyStoryName;

						MyStoriesProxy.saveNewStory(newStory, function(savedStory) {
							STORE.addStory(savedStory);
							UI.renderStoriesList();
							UI.selectStory(savedStory);
							UI.showHideTools();
							DUImessage.show(locale.get('#STORY_NAME# created successfully', 4).replace('#STORY_NAME#', HTMLHelpers.htmlEncode(savedStory.name)), 'Message-success', 5000);
						}, function() {
							$('.mystories-new-list-item', myStoriesList).remove();
						});
					}
				}).bind('keypress', function(event) {
					if (event.keyCode === 13) {
						event.preventDefault();
						this.blur();
					} else if (event.keyCode === 27) {
						$('.mystories-new-list-item', myStoriesList).remove();
					}
				});
		}

		function addSlide(position) {
			var currentStoryboardSlide = Storyboard.LayoutDesigner.getCurrentSlide();
			var selectedStory = STORE.getSelectedStory();
			var lastSelectedSlide = $('.mystories-slide.ui-selected', myStorySlides).last().data('slide');

			var newSlide = {
				storyId: selectedStory.storyId,
				name: currentStoryboardSlide.name || '',
				sortOrder: STORE.getNewSortOrderIndex(selectedStory.slides),
				settings: GeneralSettings.getSelectedSettings(),
				sourceSlideId: currentStoryboardSlide.slideId,
				sourceReportId: Helpers.getReportID(),
				hiddenSeries: Storyboard.LayoutDesigner.getHiddenSeriesFromSlide(currentStoryboardSlide)
			};

			var newStoryInput =
				'<div class="mystories-slide mystories-new-slide">' +
				'<div class="mystories-slide-thumb"></div>' +
				'<input type="text" id="txtMyStoriesNewSlideName" class="mystories-new-slide-name fullInput" value="' + newSlide.name +
				'" placeholder="' + locale.get("Name of new slide", 4) + '" />' +
				'</div>';

			UI.deselectSlides();

			if (position === 'TOP')
				$('.mystories-slide-add', myStorySlides).first().replaceWith(newStoryInput);
			else if (position === 'BOTTOM')
				$('.mystories-slide-add', myStorySlides).last().replaceWith(newStoryInput);
			else if (lastSelectedSlide)
				lastSelectedSlide.$elem.after(newStoryInput);
			else
				myStorySlides.append(newStoryInput);

			$("#txtMyStoriesNewSlideName")
				.focus()
				.bind("click", function() { return false; })
				.bind('blur', function() {
					var newSlideName = this.value.trim();
					var xssRegex = new RegExp("^[^<>=]+$");

					if (newSlideName.length === 0) {
						UI.renderStorySlides(selectedStory);
					}
					else if (!xssRegex.test(newSlideName)) {
						DUImessage.show("Slide name contains invalid characters <>=", "Message-error", 5000);
					}
					else {
						$('.mystories-new-slide-name', myStorySlides).attr('disabled', true);

						newSlide.name = newSlideName;

						if (window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART) {
							ChartCreatorDataCom.StoreDataGroup().then(function() { saveNewSlide(newSlide); });
						} else {
							saveNewSlide(newSlide);
						}

					}
				}).bind("keypress", function(event) {
					if (event.keyCode === 13) {
						event.preventDefault();
						this.blur();
					} else if (event.keyCode === 27) {
						UI.renderStorySlides(selectedStory);
					}
				});

			function saveNewSlide(newSlide) {
				MyStoriesProxy.saveNewSlide(newSlide, function(savedSlide) {
					STORE.addSlide(selectedStory, savedSlide);
					savedSlide.isLoadingThumbnail = true;

					if (position === 'TOP')
						savedSlide.sortOrder = 0;
					else if (position === 'BOTTOM')
						savedSlide.sortOrder = selectedStory.slides.length;
					else if (lastSelectedSlide)
						savedSlide.sortOrder = lastSelectedSlide.data.sortOrder + 0.5;

					STORE.updateSortOrder(selectedStory.slides);
					STORE.updateMyStorySize(selectedStory);
					UI.renderStorySlides(selectedStory);
					UI.selectSlide([savedSlide]);
					UI.showHideTools();

					DUImessage.show(locale.get("#SLIDE_NAME# added successfully", 4).replace("#SLIDE_NAME#", HTMLHelpers.htmlEncode(savedSlide.name)), 'Message-success', 5000);

					var order = myStorySlides.sortable('toArray', { attribute: 'data-id' });

					MyStoriesProxy.saveSlidesOrder(order, function() {
						selectedStory.slides.forEach(function(slide, index, slidesArray) {
							slide.sortOrder = Number(order.indexOf(String(slide.slideId))) + 1;
						});
					});
				}, function() {
					UI.renderStorySlides(selectedStory);
				});
			}
		}

		function selectStory(storyData) {
			var story = $('.mystories-list-item[data-story-id="' + storyData.storyId + '"]', myStoriesList).data('story');
			var searchKeyword = $('#txtMyStoriesSearch').val().trim().toLowerCase();

			if (story) {
				if (storyData.name.indexOf(searchKeyword) > -1)
					UI.clearSearch();

				story.select();
			}
		}

		function selectSlide(slides) {
			slides.forEach(function(slideData) {
				$('.mystories-slide[data-id="' + slideData.slideId + '"]', myStorySlides).addClass('ui-selected');
			});
		}

		function deselectStories() {
			$('.selected', myStoriesList).removeClass('selected');
			$(".mystories-menu", myStoriesList).remove();
		}

		function deselectSlides() {
			$('.ui-selected', myStorySlides).removeClass('ui-selected');
		}

		function isAddSlideAvailable() {
			var currentSlide = Storyboard.LayoutDesigner.getCurrentSlide();
			var isChartCreator = window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART;
			return Storyboard.LayoutDesigner.slideShowMode && currentSlide && (currentSlide.slideId > 0 || isChartCreator);
		}

		function isStoryOpen() {
			return myStoriesList.parent().hasClass('mystories-open-story');
		}

		function isUpdateThumbnailsAvailable() {
			return $('.mystories-slide', myStorySlides).length > 0;
		}

		function showHideTools() {
			var isStory = isStoryOpen();
			var btnAddSlide = myStoriesList.find('.mystory-add-slide');
			var mystoriesSlideAdd = myStorySlides.find('.mystories-slide-add');
			var slideNotSavedMessage = "Current slide was not saved yet and cannot be added to story. Please Save Layout and try again.";

			if (isAddSlideAvailable()) {
				btnAddSlide.removeAttr('disabled');
				mystoriesSlideAdd.removeAttr('disabled');
				btnAddSlide.attr('data-tooltip', locale.get("Add current slide", 4));
				mystoriesSlideAdd.find('.mystories-slide-add-text').text(locale.get("Add current slide", 4));
			} else {
				btnAddSlide.attr('disabled', 'disabled');
				mystoriesSlideAdd.attr('disabled', 'disabled');
				if (Storyboard.LayoutDesigner.getCurrentSlide().slideId == 0) {
					btnAddSlide.attr("data-tooltip", slideNotSavedMessage);
					mystoriesSlideAdd.find('.mystories-slide-add-text').text(slideNotSavedMessage);
				}
			}

			btnAddSlide.toggle(isStory);
			$('#btnNewStory').toggle(!isStory);
			$('#btnUpdateThumbnails').toggle(isUpdateThumbnailsAvailable());
		}


		/**
		 * Search
		 */
		function search() {
			var keyword = $('#txtMyStoriesSearch').val().trim().toLowerCase();

			if (keyword === '') {
				$('.no-results', myStoriesList).removeClass('no-results');
				$('.no-results', myStorySlides).removeClass('no-results');
				myStorySlides.parent('.no-results').removeClass('no-results');
			} else {
				$('.mystories-list-item', myStoriesList).each(function(index, storyEl) {
					var story = $(storyEl).data('story');
					var slidesSearchResults = story.data.slides.filter(function(slide) {
						return slide.name.toLowerCase().indexOf(keyword) > -1;
					});

					$(storyEl).toggleClass('no-results', slidesSearchResults.length === 0 && story.data.name.toLowerCase().indexOf(keyword) === -1);

					if ($(this).hasClass('selected')) {
						$('.mystories-slide', myStorySlides).each(function(index, slideEl) {
							var slide = $(slideEl).data('slide');
							var slideName = slide.data.name.toLowerCase();

							$(slideEl).toggleClass('no-results', slideName.indexOf(keyword) === -1);
						});

						myStorySlides.parent().toggleClass('no-results', slidesSearchResults.length === 0);
					}
				});
			}
		}

		function clearSearch() {
			$('#txtMyStoriesSearch').val('');
			$('.no-results', myStoriesList).removeClass('no-results');
			$('.no-results', myStorySlides).removeClass('no-results');
			myStorySlides.parent('.no-results').removeClass('no-results');
		}

		/**
		 * Slide info window
		 */
		function showSlideInfo() {
			var selectedSlide = $('.mystories-slide.ui-selected', myStorySlides).first().data('slide');

			var dialogAfterShow = function() {
				var selectedStory = STORE.getSelectedStory();
				var selectedSlide = $('.mystories-slide.ui-selected', myStorySlides).first().data('slide');
				var index = selectedStory.slides.indexOf(selectedSlide.data);

				loadSlideImage(selectedSlide.getImgUrl());

				$(this.windowEl)
					.data('index', index)
					.find('.DUI-WINDOW-BODY')
					.after('<button type="button" id="btnPrevMyStorySlide" class="DUIButtonIcon mystory-slide-prev" title="Previous">' +
						'<i class="DUI-icon DUI-icon-c-left"></i>' +
						'</button>' +
						'<button type="button" id="btnNextMyStorySlide" class="DUIButtonIcon mystory-slide-next" title="Next">' +
						'<i class="DUI-icon DUI-icon-c-right"></i>' +
						'</button>');

				$('#btnPrevMyStorySlide').bind('click', function() { UI.navigateSlideInfo('prev'); });
				$('#btnNextMyStorySlide').bind('click', function() { UI.navigateSlideInfo('next'); });

				$('.mystory-slide-info-go', this.windowEl).bind('click', goToSlideHanlder);
				$('.mystory-slide-info-remove', this.windowEl).bind('click', removeSlideHanlder);

				$(document).bind('keydown.slideInfoWindow', function(event) {
					switch (event.which) {
						case 37: // left arrow
							UI.navigateSlideInfo('prev');
							break;
						case 39: // right arrow
							UI.navigateSlideInfo('next');
							break;
						default:
							return;
					}
					event.preventDefault();
				});

				validateSlideInfoNavigation();
			};

			var dialogAfterClose = function() {
				$(document).unbind('keydown.slideInfoWindow');
			};

			function showSlideInfo(slide) {
				slideInfoWindow = new DUIwindow2({
					title: '<h2>' + HTMLHelpers.htmlEncode(slide.data.name) + '</h2>',
					html: slide.getSlideInfoHtml(),
					width: 960,
					cssClass: 'mystory-slide-info-window',
					buttons: [],
					afterShow: dialogAfterShow,
					afterClose: dialogAfterClose
				});
			}

			if (selectedSlide.data.settingsText == null) {
				MyStoriesProxy.getSlideSettingsText(selectedSlide.data, function(text) {
					selectedSlide.data.settingsText = text;
					showSlideInfo(selectedSlide);
				});
			} else {
				showSlideInfo(selectedSlide);
			}
		}

		var hideSlideInfo = function() {
			if (slideInfoWindow) {
				slideInfoWindow.Close();
				slideInfoWindow = null;
			}
		}

		var goToSlideHanlder = function() {
			var selectedSlide = $('.mystories-slide.ui-selected', myStorySlides).first().data('slide');
			if (selectedSlide) selectedSlide.goToSlide();
		}

		var removeSlideHanlder = function() {
			var selectedSlide = $('.mystories-slide.ui-selected', myStorySlides).first().data('slide');
			if (selectedSlide) selectedSlide.remove();
		}

		var loadSlideImage = function(url) {
			var zoomedImg = new Image();
			zoomedImg.id = 'myStorySlideInfoScreenshot';
			zoomedImg.className = 'mystory-slide-screenshot';

			zoomedImg.onload = function() {
				$(slideInfoWindow.windowEl).find('#myStorySlideInfoScreenshot').replaceWith(zoomedImg);
			};
			zoomedImg.src = url;

			if (zoomedImg && zoomedImg.src === url)
				$(slideInfoWindow.windowEl).find('#myStorySlideInfoScreenshot').replaceWith(zoomedImg);
		};

		var validateSlideInfoNavigation = function() {
			var selectedSlide = $('.mystories-slide.ui-selected', myStorySlides).first().data('slide');
			var selectedStory = STORE.getSelectedStory();
			var index = selectedStory.slides.indexOf(selectedSlide.data);

			$('#btnPrevMyStorySlide').toggle(index > 0);
			$('#btnNextMyStorySlide').toggle(index < selectedStory.slides.length - 1);
		};

		var navigateSlideInfo = function(direction) {
			var selectedSlide = $('.mystories-slide.ui-selected', myStorySlides).first().data('slide');
			var selectedStory = STORE.getSelectedStory();
			var targetSlide, targetSlideData;
			var index = selectedSlide ?
				selectedStory.slides.indexOf(selectedSlide.data) :
				parseInt($(slideInfoWindow.windowEl).data('index'), 10);

			if (!slideInfoWindow) return;

			if (direction === "prev") targetSlideData = selectedStory.slides[index - 1];
			else if (direction === "next") targetSlideData = selectedStory.slides[index + 1];
			else targetSlideData = selectedStory.slides[index + 1] || selectedStory.slides[index - 1];

			if (targetSlideData) {
				targetSlide = $('.mystories-slide[data-id="' + targetSlideData.slideId + '"]', myStorySlides).data('slide');

				$(slideInfoWindow.windowEl)
					.data('index', index)
					.find('.DUI-WINDOW-HEADER').html('<h2>' + HTMLHelpers.htmlEncode(targetSlideData.name) + '</h2>').end()
					.find('.DUI-WINDOW-BODY').html(targetSlide.getSlideInfoHtml());

				$('.mystory-slide-info-go', this.windowEl).bind('click', goToSlideHanlder);
				$('.mystory-slide-info-remove', this.windowEl).bind('click', removeSlideHanlder);

				loadSlideImage(targetSlide.getImgUrl());

				UI.deselectSlides();
				UI.selectSlide([targetSlideData]);
				validateSlideInfoNavigation();
			} else if (selectedStory.slides.length === 0) {
				UI.hideSlideInfo();
			}
		};

		/**
		 * Bind DOM Events
		 */
		function bindEvents() {
			function myStoryItemClickHandler(event) {
				var isSelected = $(this).hasClass('selected')
				var story = $(this).closest('.mystories-list-item').data('story');

				if (isSelected) {
					UI.backToStories();
				} else {
					UI.deselectSlides();
					UI.deselectStories();
					UI.selectStory(story.data);
					UI.showHideTools();
				}

				event.stopPropagation();
			}

			function myStoryMouseEnter(event) {
				var story = $(this).closest('.mystories-list-item').data('story');
				if (story) story.showButtons();
			}

			function myStoryMousLeave(event) {
				var story = $(this).closest('.mystories-list-item').data('story');
				if (story) story.hideButtons();
			}

			function myStoryAddSlideHandler(event) {
				var position;

				if ($(this).hasClass('mystories-slide-add')) {
					if ($(this).index() === 0) position = 'TOP';
					else if ($(this).index() > 0) position = 'BOTTOM';
				}

				if (!$(this).attr("disabled"))
					UI.addSlide(position);

				event.stopPropagation();
			}

			function updateThumbnailsHandler(event) {
				event.stopPropagation();
				$(this).closest('.mystories-list-item').data('story').updateThumbnails(true);
			}

			function exportMyStoryHandler(event) {
				event.stopPropagation();
				$(this).closest('.mystories-list-item').data('story').export();
			}

			function renameMyStoryHandler(event) {
				event.stopPropagation();
				$(this).closest('.mystories-list-item').data('story').rename();
			}

			function deleteMyStoryHandler(event) {
				event.stopPropagation();
				$(this).closest('.mystories-list-item').data('story').delete();
			}

			function myStoriesSlideMouseEnter(event) {
				var slide = $(this).closest('.mystories-slide').data('slide');
				if (slide) {
					slide.showButtons();
					var tooltipDelay = setTimeout(slide.showTooltip.bind(slide), 600);
					$(this).data('tooltipDelay', tooltipDelay);
				}
			}

			function myStoriesSlideMouseLeave(event) {
				var slide = $(this).closest('.mystories-slide').data('slide');
				if (slide) {
					var tooltipDelay = $(this).data('tooltipDelay');
					if (tooltipDelay) {
						clearTimeout(tooltipDelay);
						$(this).removeData('tooltipDelay');
					}
					slide.hideButtons();
					slide.hideTooltip();
				}
			}

			function showSlideInfoHandler(event) {
				var slide = $(this).closest('.mystories-slide').data('slide');
				if (slide) {
					UI.deselectSlides();
					UI.selectSlide([slide.data]);
					UI.showSlideInfo();
				}
			}

			function goToSlideHandler(event) {
				var slide = $(this).closest('.mystories-slide').data('slide');
				if (slide) slide.goToSlide();
			}

			function renameMyStorySlideHandler(event) {
				event.stopPropagation();
				event.preventDefault();
				$(this).closest('.mystories-slide').data('slide').rename();
			}

			function removeMyStorySlideHandler(event) {
				event.stopPropagation();
				$(this).closest('.mystories-slide').data('slide').remove();
			}

			function myStoriesSlideKeyup(event) {
				var DEL = 46;
				var BACKSPACE = 8;

				if (event.target === event.currentTarget &&
					(event.which === DEL || event.which === BACKSPACE))
					$(this).data('slide').remove();
			}

			function mouseWheelHandler(event) {
				// Prevent scrolling of body element
				var $this = $(this),
					scrollTop = this.scrollTop,
					scrollHeight = this.scrollHeight,
					height = $this.height(),
					delta = (event.type == 'DOMMouseScroll' ?
						event.originalEvent.detail * -40 :
						event.originalEvent.wheelDelta),
					up = delta > 0;

				var prevent = function() {
					event.stopPropagation();
					event.preventDefault();
					event.returnValue = false;
					return false;
				}

				if (!up && -delta > scrollHeight - height - scrollTop) {
					$this.scrollTop(scrollHeight);
					return prevent();
				} else if (up && delta > scrollTop) {
					$this.scrollTop(0);
					return prevent();
				}
			}

			$('#btnNewStory').bind('click', UI.newStory);
			$('#txtMyStoriesSearch').bind('keyup', UI.search);
			$('#myStoriesPanel .mystories-list-container').bind('DOMMouseScroll mousewheel', mouseWheelHandler);
			$(document).bind("DAPI.setPageNo", showHideTools);

			myStoriesList
				.delegate(".mystories-list-item", "click", myStoryItemClickHandler)
				.delegate('.mystory-update-thumbnails', 'click', updateThumbnailsHandler)
				.delegate('.mystory-add-slide', 'click', myStoryAddSlideHandler)
				.delegate('.mystory-export', 'click', exportMyStoryHandler)
				.delegate('.mystory-rename', 'click', renameMyStoryHandler)
				.delegate('.mystory-delete', 'click', deleteMyStoryHandler)
				.delegate(".mystories-list-item:not(.selected)", "mouseenter", myStoryMouseEnter)
				.delegate(".mystories-list-item:not(.selected)", "mouseleave", myStoryMousLeave)
				.delegate('.mystory-more', 'click', function(event) { event.stopPropagation(); });

			myStorySlides
				.bind('click', function(event) { event.stopPropagation(); })
				.delegate('.mystories-slide-add', 'click', myStoryAddSlideHandler)
				.delegate('.mystory-slide-info', 'click', showSlideInfoHandler)
				.delegate('.mystory-goto-slide', 'click', goToSlideHandler)
				.delegate('.mystory-slide-rename', 'click', renameMyStorySlideHandler)
				.delegate('.mystory-slide-remove', 'click', removeMyStorySlideHandler)
				.delegate('.mystories-slide-name', 'dblclick', renameMyStorySlideHandler)
				.delegate(".mystories-slide:not(.mystories-new-slide)", "mouseenter", myStoriesSlideMouseEnter)
				.delegate(".mystories-slide:not(.mystories-new-slide)", "mouseleave", myStoriesSlideMouseLeave)
				.delegate(".mystories-slide", "keyup", myStoriesSlideKeyup);

			addResizableToMyStoriesPanel();
			addSortableToStories();
			addSelectableToSlides();
			addSortableToSlides();
		}

		return {
			newStory: newStory,
			addSlide: addSlide,
			selectStory: selectStory,
			selectSlide: selectSlide,
			deselectStories: deselectStories,
			deselectSlides: deselectSlides,
			backToStories: backToStories,
			renderStoriesList: renderStoriesList,
			renderStorySlides: renderStorySlides,
			bindEvents: bindEvents,
			showHideTools: showHideTools,
			search: search,
			clearSearch: clearSearch,
			showSlideInfo: showSlideInfo,
			hideSlideInfo: hideSlideInfo,
			navigateSlideInfo: navigateSlideInfo,
			reloadSlideThumbnails: reloadSlideThumbnails,
			renderAddSlideButtons: renderAddSlideButtons,
			renderRowsSeparators: renderRowsSeparators,
			setSlidesContainerHeight: setSlidesContainerHeight
		};
	}());


	function loadMyStories() {
		if (!isLoaded)
			MyStoriesProxy.loadUserStories(
				function(data) {
					isLoaded = true;
					STORE.stories = data;
					var sharedStories = data.filter(function(myStory) { return myStory.isShared === true; });
					sharedStories.forEach(function(story) {
						STORE.deleteStory(story);
					});
					UI.bindEvents();
					UI.renderStoriesList();
					UI.showHideTools();

					var sessionData = getSessionStorage();
					if (sessionData && sessionData.selectedStoryId) {
						var selectedStory = STORE.stories.filter(function(story) { return story.storyId === sessionData.selectedStoryId; });
						if (selectedStory.length > 0) {
							UI.selectStory(selectedStory[0]);
							setTimeout(UI.setSlidesContainerHeight, 250);
						}
					} else {
						setSessionStorage({ open: true });
					}

					showMyStoriesPanel();
				},
				function() {
					DUImessage.show(locale.get('Unable to load My Stories'), 'Message-error', 5000);
				}
			);
	}

	function openMyStoriesOnPageLoad() {
		var sessionData = getSessionStorage();
		if (sessionData && sessionData.open === true)
			$(document).bind('DAPI.slidesLoaded', function openMyStoriesHandler() {
				openMyStories();
				$(document).unbind('DAPI.slidesLoaded', openMyStoriesHandler);
			});
	}

	function openMyStories() {
		if (isLoaded) {
			UI.showHideTools();
			showMyStoriesPanel();
		} else {
			myStoriesList = $('#myStoriesList');
			myStorySlides = $('#myStorySlides');
			loadMyStories();
		}
	}

	function showMyStoriesPanel() {
		$("#myStoriesPanel").addClass('show').show();
		$("#btnMyStories").addClass('show');
	}

	function closeMyStories() {
		var selectedStory = STORE.getSelectedStory();
		$("#myStoriesPanel").removeClass('show').hide();
		$("#btnMyStories").removeClass('show');
		$("#myStoriesPanel #close_downloadSelectedPowerpoint").click();
		setSessionStorage({
			open: false,
			selectedStoryId: selectedStory ? selectedStory.storyId : null
		});
	}

	function toggleMyStories() {
		if ($('#myStoriesPanel').hasClass('show'))
			closeMyStories();
		else
			openMyStories();
	}

	//
	// Public
	//
	sb.MyStories.openMyStories = openMyStories;
	sb.MyStories.closeMyStories = closeMyStories;
	sb.MyStories.toggleMyStories = toggleMyStories;
	sb.MyStories.setupSharingWithUsers = setupSharingWithUsers;
	sb.MyStories.setupSharingWithGroups = setupSharingWithGroups;
	sb.MyStories.saveStorySharingSettings = saveStorySharingSettings;
	sb.MyStories.BindStorySharingSettings = BindStorySharingSettings;
	sb.MyStories.updateShareButtonContent = updateShareButtonContent;
	sb.MyStories.bindSharingOptions = bindSharingOptions;
	sb.MyStories.toggleSharingOptions = toggleSharingOptions;
	sb.MyStories.getCurrentStory = getCurrentStory;

	$(document).ready(function() {
		if (window.IsStoryboard || window.IsMyStories) {
			$('#btnMyStories, #btnMyStories_cc').unbind().bind('click', toggleMyStories);
			$("#DUI-ST-CLOSEMYSTORIESPANEL").unbind().bind('click', closeMyStories);
			$('#chbShareWithIndividual, #chbShareWithGroup').unbind('change').bind('change', onSharingTypeChanged);

			if (window.IsStoryboard && $('#btnMyStories, #btnMyStory2').length > 0)
				openMyStoriesOnPageLoad();
		}

		if (window.IsMyStories) {
			$("#divStoriesContainer #lblName").html(locale.get("Select story", 4));
			$("#lnkDeleteMyStoriesSlide").html(locale.get("Remove slide", 4));
			$("#lnkMyStoriesSourceSlide").html(locale.get("Go to source slide", 4));
			$("#btnMyStoriesShare").html(locale.get("Share Story...", 4));
		} else if (window.IsStoryboard) {
			$("#btnMyStories, #btnMyStory2").text(locale.get("My Stories panel", 4));
			$("#lblStoryPanelHeader").html(locale.get("My Stories", 4));
			$("#DUI-ST-CLOSEMYSTORIESPANEL").attr("title", locale.get("Close this panel", 4));
			$("#txtMyStoriesSearch").attr("placeholder", locale.get("Search", 4));
			$("#btnNewStory").html("<i class='DUI-icon DUI-icon-c-plus'></i>" + locale.get("New Story", 4));
		}
	});

	//
	//Sharing
	//
	function onSharingTypeChanged() {
		var box = $(this);

		var itemType = 'MyStories';
		var msg;
		switch (box.attr('id')) {
			case 'chbShareWithAll':
				msg = 'The project contains {{items}} shared with all users, these {{items}} will become unshared.';
				checkIfNeedToUnshare(box, [1], msg, itemType);
				break;
			case 'chbShareWithIndividual':
				msg = 'The project contains {{items}} shared with individual Report users, these {{items}} will become unshared.';
				checkIfNeedToUnshare(box, [2, 4], msg, itemType, toggleSharingWithUsers);
				break;
			case 'chbShareWithGroup':
				msg = 'The project contains {{items}} shared with user groups, these {{items}} will become unshared.';
				checkIfNeedToUnshare(box, [8, 16], msg, itemType, toggleSharingWithGroups);
				break;
			case 'chbShareWithAdmins':
				msg = 'The project contains {{items}} shared with individual Administrator, these {{items}} will become unshared.';
				checkIfNeedToUnshare(box, [32], msg, itemType);
				break;

			case 'optShareWithIndWithinGroup':
				msg = 'The project contains {{items}} shared with individual Report users, these {{items}} will become unshared.';
				checkIfNeedToAdjust(box, [4], msg, itemType);
				break;
			case 'optShareWithOwnGroup':
				msg = 'The project contains {{items}} shared with user groups, these {{items}} will become unshared.';
				checkIfNeedToAdjust(box, [16], msg, itemType);
				break;
		}
	}
	function checkIfNeedToUnshare(box, sharingTypes, message, itemType, callback) {
		message = message.replace(new RegExp('{{items}}', 'g'), itemType);

		if (!box.attr('checked') && sharingTypes && sharingTypes.length > 0) {
			var anyToUnshare = false;

			if (anyToUnshare) {
				new DUIwindow2({
					closeButton: false,
					width: 340,
					height: 'auto',
					html: message,
					buttons: [{
						text: locale.get("Continue"),
						onClick: function() { if (callback) callback(); }
					}, {
						text: locale.get("Cancel"), focused: true,
						onClick: function() { $(box).attr('checked', 'checked'); }
					}]
				});
			} else if (callback) callback();

		} else if (callback) callback();
	}

	function checkIfNeedToAdjust(box, sharingTypes, itemType, message) {
		message = message.replace(new RegExp('{{items}}', 'g'), itemType);

		if (box.attr('checked') && sharingTypes && sharingTypes.length > 0) {
			var anyToAdjust = false;
			if (anyToAdjust) {
				new DUIwindow2({
					closeButton: false,
					width: 340,
					height: 'auto',
					html: message,
					buttons: [{
						text: locale.get("Continue"), close: true
					}, {
						text: locale.get("Cancel"), focused: true,
						onClick: function() {
							var rbGroupName = $(box).attr('name');
							$('input[name="' + rbGroupName + '"]').removeAttr('checked');
							if (rbGroupName == 'opShareWithIndividual')
								$('#optShareWithAllInd').attr('checked', 'checked');
							else if (rbGroupName == 'opShareWithGroup')
								$('#optShareWithAllGroups').attr('checked', 'checked');
						}
					}]
				});
			}
		}
	}


	function getCurrentStory() {
		return myStories.find(o => o.storyId === parseInt($("#ddlMyStories").val()));
	}
	var projHasUserGroups = false;
	function bindSharingOptions(projectHasUserGroups) {
		projHasUserGroups = projectHasUserGroups
		$('#chbSharedStories').attr('checked', Storyboard.LayoutDesigner.enableMyStoriesSharing);
		var story = myStories.find(o => o.storyId === parseInt($("#ddlMyStories").val()));

		if (Storyboard.LayoutDesigner.enableMyStoriesSharing && story?.isShared == false) {
			$("#btnMyStoriesShare").css("display", "inline-block");
		}

		$('input.storySharingType').removeAttr('checked');
		$('#chbShareWithIndividual').removeAttr('checked');
		$('input.storySharingType').each(function() {
			var val = parseInt($(this).val() || 0, 10);
			if ((val & Storyboard.LayoutDesigner.myStoriesSharingType) == val) {
				$(this).attr('checked', true);
				if (val == Storyboard.Constants.FavoriteSharingType.IndividualUsersWithinGroup || val == Storyboard.Constants.FavoriteSharingType.AllIndividualUsers)
					$('#chbShareWithIndividual').attr('checked', true);
				else if (val == Storyboard.Constants.FavoriteSharingType.OwnGroup || val == Storyboard.Constants.FavoriteSharingType.AllGroups)
					$('#chbShareWithGroup').attr('checked', true);
			}
		});
		toggleSharingOptions(projectHasUserGroups);
	}

	function toggleSharingOptions(projectHasUserGroups) {
		var story = myStories.find(o => o.storyId === parseInt($("#ddlMyStories").val()));

		var sharingEnabled = $('#chbSharedStories').attr('checked');
		if (sharingEnabled && story?.isShared == false) {
			$("#btnMyStoriesShare").css("display", "inline-block");
		}
		else {
			$("#btnMyStoriesShare").css("display", "none");
		}
		$('.storiesSharingSettings').toggle(sharingEnabled);
		$('#chbShareWithGroup').closest('div').toggle(projectHasUserGroups);

		toggleSharingWithUsers(projectHasUserGroups);
		toggleSharingWithGroups(projectHasUserGroups);
	}

	function toggleSharingWithUsers(projectHasUserGroups) {

		var userSharingEnabled = $('#chbShareWithIndividual').attr('checked');
		$('#optShareWithIndWithinGroup, #optShareWithAllInd').closest('span').toggle(userSharingEnabled && projHasUserGroups);

		if (!userSharingEnabled) {
			$('#optShareWithIndWithinGroup, #optShareWithAllInd').removeAttr('checked');
		} else if (!projHasUserGroups)
			$('#optShareWithAllInd').attr('checked', true);
		else if ($('#optShareWithIndWithinGroup:checked, #optShareWithAllInd:checked').length == 0)
			$('#optShareWithIndWithinGroup').attr('checked', true);
	}

	function toggleSharingWithGroups(projectHasUserGroups) {

		var groupSharingEnabled = projHasUserGroups && $('#chbShareWithGroup').attr('checked');
		$('#optShareWithOwnGroup, #optShareWithAllGroups').closest('span').toggle(groupSharingEnabled);
		if (!groupSharingEnabled) {
			$('#optShareWithOwnGroup, #optShareWithAllGroups').removeAttr('checked');
		} else if ($('#optShareWithOwnGroup:checked, #optShareWithAllGroups:checked').length == 0)
			$('#optShareWithOwnGroup').attr('checked', true);
	}

	function BindStorySharingSettings(projectHasUserGroups) {
		$('.storySharingCheck > input:checkbox').removeAttr('checked');
		$('#tblShareStoryWithGroupsInfoTable').dataTable().fnClearTable();
		$('#tblShareStoryWithUsersInfoTable').dataTable().fnClearTable();
		var currentStory = myStories.find(o => o.storyId === parseInt($("#ddlMyStories").val()));

		$('#hidEditSharingStoryId').val($("#ddlMyStories").val());
		if (Storyboard.Constants.FavoriteSharingType.hasUserSharingTypeFlag(currentStory?.sharingType)) {
			// special case for sharing with users since it can have two sharing type flags at the same time
			$('#cbShareWithUsers_ms').attr('checked', true);
		} else
			$('.storySharingCheck > input:checkbox[value="' + currentStory.sharingType + '"]').attr('checked', true);
		Helpers.perfJSonCall({
			method: 'LoadUsersFromMyStoriesSharingForStoryId',
			data: { storyId: currentStory.storyId },
			successCallback: function(userIds) {
				if (currentStory.sharingType === Storyboard.Constants.FavoriteSharingType.AllGroups) {
					LoadGroupsSharingTable(function() { BindSharedWithGroupsInfoTable(userIds); }, userIds);
				}
				else if (Storyboard.Constants.FavoriteSharingType.hasUserSharingTypeFlag(currentStory.sharingType)) {
					LoadUsersSharingTable(function() { BindSharedWithUsersInfoTable(userIds); }, userIds);
				}
				showHideShareWithTables(projectHasUserGroups);
			},
			service: 'MyStory',
			fixCasing: true
		});
	}

	function showHideShareWithTables(projectHasUserGroups) {
		$('.storySharingWithUsers').toggle($('#cbShareWithUsers_ms').attr('checked'));
		$('.storySharingWithGroups').toggle(projectHasUserGroups && $('#cbShareWithGroups_ms').attr('checked'));
	}
	function BindSharedWithUsersInfoTable(userIds) {
		$('#tblShareStoryWithUsersInfoTable').dataTable().fnClearTable();
		$(userIds).each(function() {
			addSharedWithUserInfoRow(parseInt(this, 10));
		});
		updateSharedWithUserInfoLayout();
	}
	function BindSharedWithGroupsInfoTable(groupUserIds) {
		$('#tblShareStoryWithGroupsInfoTable').dataTable().fnClearTable();
		$(groupUserIds).each(function() {
			addSharedWithGroupInfoRow(parseInt(this, 10));
		});
		updateSharedWithGroupInfoLayout();
	}

	function closeStoryModal(storyModal) {
		if (storyModal)
			storyModal.Close();
	}

	function saveStorySharingSettings(storyModal) {
		UpdateStorySharing(GetEditedSharingSettings(), function() {
			updateShareButtonContent();
			closeStoryModal(storyModal);
		});
	}
	function UpdateStorySharing(details, callback) {
		Helpers.perfJSonCall({
			method: 'UpdateStorySharingSettings',
			data: {
				storyId: details.storyId,
				sharingType: details.sharingType,
				userIds: details.sharedWithUsers
			},
			successCallback: function(result) {
				var objIndex = myStories.findIndex((obj => obj.storyId == result.storyId));
				myStories[objIndex].sharingType = result.sharingType;
				myStories[objIndex].noOfSharedUsers = result.noOfSharedUsers;

				if (callback) callback();
				DUImessage.show('Story sharing settings were updated successfully', 'Message-success', 5000);
			},
			service: 'MyStory',
			message: 'Saving sharing settings',
			fixCasing: true
		});
	}
	function GetEditedSharingSettings() {
		var settings = {
			storyId: $('#hidEditSharingStoryId').val(),
			sharingType: $('.storySharingCheck > input:checkbox:checked').length > 0 ? parseInt($('.storySharingCheck > input:checkbox:checked').val(), 10) : 0,
			sharedWithUsers: []
		};

		if (Storyboard.Constants.FavoriteSharingType.hasUserSharingTypeFlag(settings.sharingType))
			settings.sharedWithUsers = GetSharedWithUsersFromStoryInfoPanel();
		else if (settings.sharingType === Storyboard.Constants.FavoriteSharingType.AllGroups)
			settings.sharedWithUsers = GetSharedWithGroupUsersFromStoryInfoPanel();

		return settings;
	}
	function GetSharedWithUsersFromStoryInfoPanel() {
		var vsUser = [];
		$('#tblShareStoryWithUsersInfoTable .hidSharedWithUserId_ms').each(function() {
			vsUser.push({ userId: parseInt($(this).val(), 10) });
		});

		return vsUser;
	}
	function GetSharedWithGroupUsersFromStoryInfoPanel() {
		var vsGroupUser = [];
		$('#tblShareStoryWithGroupsInfoTable .hidSharedWithGroupUserId_ms').each(function() {
			vsGroupUser.push({ userId: parseInt($(this).val(), 10) });
		});

		return vsGroupUser;
	}

	function setupSharingWithUsers(projectHasUserGroups) {
		var UsersToShareWithTable = $('#tblUsersToShareWith_ms').dataTable({
			"sScrollY": "400px",
			"bRetrieve": true,
			"bPaginate": false,
			"bInfo": false,
			"bSortCellsTop": true,
			"sDom": 'lrtip',
			"asStripeClasses": ['userToShareWithRow_ms'],
			"aaSorting": [[1, "asc"]],
			"aoColumnDefs": [
				{ "sClass": "shareWithUser_ms", "sWidth": "40px", "aTargets": [0] },
				{ "sClass": "userName_ms", "aTargets": [1], "fnRender": function(data) { return HTMLHelpers.htmlEncode(data.aData[1]); } },
				{ "sClass": "userEmail_ms", "aTargets": [2], "fnRender": function(data) { return HTMLHelpers.htmlEncode(data.aData[2]); } },
				{ "sClass": "userGroup_ms", "aTargets": [2], "fnRender": function(data) { return HTMLHelpers.htmlEncode(data.aData[3]); } }
			]
		});

		var AdminsToShareWithTable = $('#tblAdminsToShareWith_ms').dataTable({
			"sScrollY": "400px",
			"bRetrieve": true,
			"bPaginate": false,
			"bInfo": false,
			"bSortCellsTop": true,
			"sDom": 'lrtip',
			"asStripeClasses": ['userToShareWithRow_ms'],
			"aaSorting": [[1, "asc"]],
			"aoColumnDefs": [
				{ "sClass": "shareWithUser_ms", "sWidth": "40px", "aTargets": [0] },
				{ "sClass": "userName_ms", "aTargets": [1], "fnRender": function(data) { return HTMLHelpers.htmlEncode(data.aData[1]); } },
				{ "sClass": "userEmail_ms", "aTargets": [2], "fnRender": function(data) { return HTMLHelpers.htmlEncode(data.aData[2]); } },
				{ "sClass": "userGroup_ms", "aTargets": [2], "fnRender": function(data) { return HTMLHelpers.htmlEncode(data.aData[3]); } }
			]
		});

		if (!projectHasUserGroups)
			$('#tblUsersToShareWith_ms').dataTable().fnSetColumnVis(3, false);

		$('#tblUsersToShareWith_ms, #tblAdminsToShareWith_ms').delegate('.cbShareWithUser_ms', 'change', function() {
			var userId = parseInt($(this).val(), 10);
			if ($(this).is(':checked')) addSharedWithUserInfoRow(userId);
			else removeSharedWithUserInfoRow(userId);
			updateSharedWithUserInfoLayout();
		});

		$("#tblUsersToShareWith_ms")
			.closest(".dataTables_wrapper").find(".dataTables_scrollHead thead tr + tr th > input:text")
			.bind('input change', function() {
				UsersToShareWithTable.fnFilter(this.value, $(this).parent().index());
			});
		$("#tblAdminsToShareWith_ms")
			.closest(".dataTables_wrapper").find(".dataTables_scrollHead thead tr + tr th > input:text")
			.bind('input change', function() {
				AdminsToShareWithTable.fnFilter(this.value, $(this).parent().index());
			});

		$('.cbToggleShareWithUsers_ms').bind('change', function() {
			var checked = $(this).is(':checked');
			var tableId = $(this).closest('.dataTables_wrapper').find('.usersToShareWithTable[id]').attr('id') === 'tblUsersToShareWith_ms' ? '#tblUsersToShareWith_ms' : '#tblAdminsToShareWith_ms';
			$(tableId + ' .cbShareWithUser_ms').each(function() {
				$(this).attr('checked', checked);
				var userId = parseInt($(this).val(), 10);
				if (checked) addSharedWithUserInfoRow(userId);
				else removeSharedWithUserInfoRow(userId);
			});
			updateSharedWithUserInfoLayout();
		});

		$('#tblShareStoryWithUsersInfoTable').dataTable({
			"sScrollY": "400px",
			"bRetrieve": true,
			"bPaginate": false,
			"bInfo": false,
			"bSort": false,
			"sDom": 'lrtip',
			"asStripeClasses": ['sharedWithUserInfoRow_ms'],
			"aoColumnDefs": [
				{ "sClass": "sharedWithUserId_ms", "aTargets": [0], "sWidth": 0 },
				{ "sClass": "sharedWithUserNameEmail_ms", "aTargets": [1], "fnRender": function(data) { return HTMLHelpers.htmlEncode(data.aData[1]); } },
				{ "bSearchable": false, "bSortable": false, "sWidth": "40px", "sClass": "sharedWithUserDelete_ms", "aTargets": [2] }
			]
		});


		$('#tblShareStoryWithUsersInfoTable').delegate('.sharedWithUserDelete_ms', 'click', function() {
			var userId = $(this).closest('.sharedWithUserInfoRow_ms').find('.hidSharedWithUserId_ms').val();
			removeSharedWithUserInfoRow(userId);
			updateSharedWithUserInfoLayout();
		});

		$('#btnAddRemoveStoryUsers').unbind().bind('click', function(e) {
			e.preventDefault();
			LoadUsersSharingTable(function() {
				checkSharedUsersFromStoryInfoPanel();
				openSharingPanel($('#shareWithUsersPanel_ms'));
			}, null);
		});
	}
	function addSharedWithUserInfoRow(userId) {
		if ($('.hidSharedWithUserId_ms[value="' + userId + '"]').length > 0)
			return;

		var userRow = $('.usersToShareWithTable .cbShareWithUser_ms[value="' + userId + '"]').closest('.userToShareWithRow_ms').get(0);
		if (userRow) {
			var tableId = $(userRow).closest('.usersToShareWithTable').attr('id') === 'tblUsersToShareWith_ms' ? '#tblUsersToShareWith_ms' : '#tblAdminsToShareWith_ms';
			var userInfo = $(tableId).dataTable().fnGetData(userRow);

			var idColumn = '<input type="hidden" id="hidSharedWithUserId_ms" class="hidSharedWithUserId_ms" value="{{userId}}">';
			var userNameEmail = userInfo[1] + ' - ' + userInfo[2];
			var deleteButton = '<button type="button" class="DUIButtonIcon btnSharedWithUserDelete_ms float-right" title="Delete"><i class="DUI-icon DUI-icon-close"></i></button>';

			$('#tblShareStoryWithUsersInfoTable').dataTable().fnAddData([
				idColumn.replace('{{userId}}', userId),
				userNameEmail,
				deleteButton
			], false);
		}
	}
	function removeSharedWithUserInfoRow(userId) {
		var node = $(".hidSharedWithUserId_ms[value='" + userId + "']").closest(".sharedWithUserInfoRow_ms").get(0);
		if (node != undefined)
			$("#tblShareStoryWithUsersInfoTable").dataTable().fnDeleteRow(node, null, false);
	}
	function updateSharedWithUserInfoLayout() {
		var anySelectedUsers = Boolean($('#tblShareStoryWithUsersInfoTable').dataTable().fnSettings().aoData.length);

		if (anySelectedUsers) {
			$('.storySharingWithUsers > h3').show();
			$('#btnAddRemoveStoryUsers').text('Add/remove users...');
		} else {
			$('.storySharingWithUsers > h3').hide();
			$('#btnAddRemoveStoryUsers').text('Add users...');
		}

		$('#tblShareStoryWithUsersInfoTable').dataTable().fnDraw();
	}

	function LoadUsersSharingTable(callback, userIds) {
		if (!userIds) userIds = null;

		Helpers.perfJSonCall({
			method: 'LoadUsersForSharing',
			data: { storyId: $('#ddlMyStories').val(), userIds: userIds },
			successCallback: function(users) {
				BindUsersForSharing(users);
				if (callback) callback();
			},
			service: 'MyStory',
			message: 'Loading users',
			fixCasing: true
		});
	}

	function checkSharedUsersFromStoryInfoPanel() {
		$('#tblUsersToShareWith_ms .cbShareWithUser_ms, #tblAdminsToShareWith_ms .cbShareWithUser_ms').removeAttr('checked');

		$('#tblShareStoryWithUsersInfoTable .hidSharedWithUserId_ms').each(function() {
			var userId = parseInt($(this).val(), 10);
			$('#tblUsersToShareWith_ms .cbShareWithUser_ms[value="' + userId + '"]').attr('checked', 'checked');
			$('#tblAdminsToShareWith_ms .cbShareWithUser_ms[value="' + userId + '"]').attr('checked', 'checked');
		});
	}

	function BindUsersForSharing(users) {
		$('#shareWithUsersPanel_ms').show();
		$('#tblUsersToShareWith_ms').dataTable().fnClearTable();
		$('#tblAdminsToShareWith_ms').dataTable().fnClearTable();
		$(users).each(function() { addUserToShareWithRow(this); })
		$('#tblUsersToShareWith_ms').dataTable().fnDraw();
		$('#tblAdminsToShareWith_ms').dataTable().fnDraw();
		$('#shareWithUsersPanel_ms').hide();
	}
	function addUserToShareWithRow(user) {
		var shareColumn = '<input type="checkbox" id="cbShareWithUser" class="cbShareWithUser_ms" value="{{userId}}">';
		var tableId = user.isAdminOrPm ? '#tblAdminsToShareWith_ms' : '#tblUsersToShareWith_ms';
		$(tableId).dataTable().fnAddData([
			shareColumn.replace('{{userId}}', user.userId),
			user.userName,
			user.email,
			user.userGroups && user.userGroups.length > 0 ? user.userGroups[0].groupName : ""
		], false);
	}

	function setupSharingWithGroups() {
		var GroupsToShareWithTable = $('#tblGroupsToShareWith_ms').dataTable({
			"sScrollY": "400px",
			"bRetrieve": true,
			"bPaginate": false,
			"bInfo": false,
			"bSortCellsTop": true,
			"sDom": 'lrtip',
			"asStripeClasses": ['groupToShareWithRow_ms'],
			"aaSorting": [[1, "asc"]],
			"aoColumnDefs": [
				{ "sClass": "shareWithGroup_ms", "sWidth": "40px", "aTargets": [0] },
				{ "sClass": "groupName_ms", "aTargets": [1], "fnRender": function(data) { return HTMLHelpers.htmlEncode(data.aData[1]); } },
			]
		});

		$('#tblGroupsToShareWith_ms').delegate('.cbShareWithGroup_ms', 'change', function() {
			var groupUserId = parseInt($(this).val(), 10);
			if ($(this).is(':checked')) addSharedWithGroupInfoRow(groupUserId);
			else removeSharedWithGroupInfoRow(groupUserId);
			updateSharedWithGroupInfoLayout();
		});

		$("#tblGroupsToShareWith_ms")
			.closest(".dataTables_wrapper").find(".dataTables_scrollHead thead tr + tr th > input:text")
			.bind('input change', function() {
				GroupsToShareWithTable.fnFilter(this.value, $(this).parent().index());
			});

		$('#cbToggleShareWithGroups_ms').bind('change', function() {
			var checked = $(this).is(':checked');
			$('#tblGroupsToShareWith_ms .cbShareWithGroup_ms').each(function() {
				$(this).attr('checked', checked);
				var groupUserId = parseInt($(this).val(), 10);
				if (checked) addSharedWithGroupInfoRow(groupUserId);
				else removeSharedWithGroupInfoRow(groupUserId);
			});
			updateSharedWithGroupInfoLayout();
		});

		$('#tblShareStoryWithGroupsInfoTable').dataTable({
			"sScrollY": "400px",
			"bRetrieve": true,
			"bPaginate": false,
			"bInfo": false,
			"bSort": false,
			"bSortCellsTop": false,
			"sDom": 'lrtip',
			"asStripeClasses": ['sharedWithGroupInfoRow_ms'],
			"aoColumnDefs": [
				{ "sClass": "sharedWithGroupUserId_ms", "aTargets": [0] },
				{ "sClass": "sharedWithGroupName_ms", "aTargets": [1], "fnRender": function(data) { return HTMLHelpers.htmlEncode(data.aData[1]); } },
				{ "bSearchable": false, "bSortable": false, "sWidth": "40px", "sClass": "sharedWithGroupDelete_ms", "aTargets": [2] }
			]
		});

		$('#tblShareStoryWithGroupsInfoTable').delegate('.sharedWithGroupDelete_ms', 'click', function() {
			var groupUserId = $(this).closest('.sharedWithGroupInfoRow_ms').find('.hidSharedWithGroupUserId_ms').val();
			removeSharedWithGroupInfoRow(groupUserId);
			updateSharedWithGroupInfoLayout();
		});

		$('#btnAddRemoveStoryGroups').unbind().bind('click', function(e) {
			e.preventDefault();
			LoadGroupsSharingTable(function() {
				checkSharedGroupsFromStoryInfoPanel();
				openSharingPanel($('#shareWithGroupsPanel_ms'));
			}, null);
		});
	}
	function addSharedWithGroupInfoRow(groupUserId) {
		if ($('.hidSharedWithGroupUserId_ms[value="' + groupUserId + '"]').length > 0)
			return;

		var groupRow = $('#tblGroupsToShareWith_ms .cbShareWithGroup_ms[value="' + groupUserId + '"]').closest('.groupToShareWithRow_ms').get(0);
		if (groupRow) {
			var groupInfo = $('#tblGroupsToShareWith_ms').dataTable().fnGetData(groupRow);

			var idColumn = '<input type="hidden" id="hidSharedWithGroupUserId_ms" class="hidSharedWithGroupUserId_ms" value="{{groupUserId}}">';
			var deleteButton = '<button type="button" class="DUIButtonIcon btnSharedWithGroupDelete_ms float-right" title="Delete"><i class="DUI-icon DUI-icon-close"></i></button>';

			$('#tblShareStoryWithGroupsInfoTable').dataTable().fnAddData([
				idColumn.replace('{{groupUserId}}', groupUserId),
				groupInfo[1],
				deleteButton
			], false);
		}
	}
	function removeSharedWithGroupInfoRow(groupUserId) {
		var node = $(".hidSharedWithGroupUserId_ms[value='" + groupUserId + "']").closest(".sharedWithGroupInfoRow_ms").get(0);
		if (node != undefined)
			$("#tblShareStoryWithGroupsInfoTable").dataTable().fnDeleteRow(node, null, false);
	}
	function updateSharedWithGroupInfoLayout() {
		var anySelectedGroups = Boolean($('#tblShareStoryWithGroupsInfoTable').dataTable().fnSettings().aoData.length);

		if (anySelectedGroups) {
			$('.storySharingWithGroups > h3').show();
			$('#btnAddRemoveStoryGroups').text('Add/remove user groups...');
		} else {
			$('.storySharingWithGroups > h3').hide();
			$('#btnAddRemoveStoryGroups').text('Add user groups...');
		}

		$('#tblShareStoryWithGroupsInfoTable').dataTable().fnDraw();
	}
	function LoadGroupsSharingTable(callback, groupIds) {
		if (!groupIds) groupIds = null;

		if (!groupsForSharingLoaded) {
			Helpers.perfJSonCall({
				method: 'LoadGroupsForSharing',
				data: { groupUserIds: groupIds, storyId: $('#ddlMyStories').val() },
				successCallback: function(groups) {
					BindGroupsForSharing(groups);
					if (callback) callback();
				},
				service: 'MyStory',
				message: 'Loading groups',
				fixCasing: true
			});
		} else if (callback) callback();
	}
	function BindGroupsForSharing(groups) {
		$('#shareWithGroupsPanel_ms').show();
		$('#tblGroupsToShareWith_ms').dataTable().fnClearTable();
		$(groups).each(function() { addGroupToShareWithRow(this); });
		$('#tblGroupsToShareWith_ms').dataTable().fnDraw();
		$('#shareWithGroupsPanel_ms').hide();
	}
	function addGroupToShareWithRow(group) {
		var shareColumn = '<input type="checkbox" id="cbShareWithGroup" class="cbShareWithGroup_ms" value="{{userGroupId}}">';
		$('#tblGroupsToShareWith_ms').dataTable().fnAddData([
			shareColumn.replace('{{userGroupId}}', (-group.userGroupId)),
			group.groupName
		], false);
	}
	function checkSharedGroupsFromStoryInfoPanel() {
		$('#tblGroupsToShareWith_ms .cbShareWithGroup_ms').removeAttr('checked');

		$('#tblShareStoryWithGroupsInfoTable .hidSharedWithGroupUserId_ms').each(function() {
			var groupUserId = parseInt($(this).val(), 10);
			$('#tblGroupsToShareWith_ms .cbShareWithGroup_ms[value="' + groupUserId + '"]').attr('checked', 'checked');
		});
	}

	function removeSearchValues (optionsPopup) {
		$("#tblUsersToShareWith_ms, #tblAdminsToShareWith_ms, #tblGroupsToShareWith_ms").closest(".dataTables_wrapper").find(".dataTables_scrollHead thead tr + tr th > input:text").each(function (index, searchBox) {
			$(searchBox).val('');
			$(searchBox).trigger('change');
		});
		closeSharingPanel($(optionsPopup).closest('.DUI-OptionsPopup'));
    }

	function openSharingPanel(panel) {
		let checkedSharedUsers = $('input.cbShareWithUser_ms[type="checkbox"]:checked, input.cbShareWithGroup_ms[type="checkbox"]:checked').map(function () {
			return $(this).val();
		});

		var isWindow = panel.closest('.DUI-WINDOW-OUTER').length > 0;

		$('#btnApplyUsersShare_ms, #btnApplyGroupShare_ms', panel).unbind('click').bind('click', function () {
			removeSearchValues(this); 
		});

		$('#btnCancelUsersShare_ms, .shareWithPanelClose, #btnCancelGroupShare_ms', panel).unbind('click').bind('click', function () {
			$('input.cbShareWithUser_ms[type="checkbox"], input.cbShareWithGroup_ms[type="checkbox"]').each(function () {
				if ($.inArray($(this).val(), checkedSharedUsers) === -1) {
					if ($(this)[0].checked) {
						$(this).click();
					}
				} else {
					if (!$(this)[0].checked) {
						$(this).click();
					}
                }
			});
			removeSearchValues(this);			
		});		

		panel.addClass('open').css('display', 'block');

		if (isWindow) {
			panel.closest('.DUI-WINDOW-2').css({ position: 'static' }).find('.DUI-WINDOW-CLOSE').css('display', 'none');
			panel.closest('.DUI-WINDOW-2').before('<div class="share-with-setup-overlay" style="position: absolute; min-height: ' + (panel.outerHeight() + 40) + 'px"></div>');
		} else {
			panel.before('<div class="share-with-setup-overlay"></div>');
		}

		panel.css({
			width: panel.width(),
			zIndex: 10000
		});

		panel.position({
			of: isWindow ? $('.share-with-setup-overlay') : window,
			my: 'center center',
			at: 'center center'
		});

		$('.DUITable[id]', panel).each(function() {
			$(this).closest('.dataTables_wrapper').find('th, td').css({ width: '', height: '' });
			$(this).dataTable().fnAdjustColumnSizing();
		});

		addDragableToSharingPanel(panel);
	}

	function closeSharingPanel(panel) {
		panel.closest('.DUI-WINDOW-2').css({ position: '' }).find('.DUI-WINDOW-CLOSE').css('display', '');
		panel.removeClass('open').css('display', 'none');
		panel.draggable('destroy').unbind('mousedown');
		$('.share-with-setup-overlay').remove();
	}

	function addDragableToSharingPanel(panel) {
		panel
			.draggable({
				cancel: 'input,textarea,button,select,option',
				stop: function(event) {
					panel.addClass('positioned drag-stopped');
				}
			})
			.bind('mousedown', function(event) {
				panel.find('input:focus').blur();
			});
	}

	function updateShareButtonContent() {
		var story = myStories.find(o => o.storyId === parseInt($("#ddlMyStories").val()));
		var openSharePanelText = Storyboard.Constants.FavoriteSharingType.getCTFavoriteText({
			sharingType: story.sharingType,
			sharedWithUsers: Array(typeof story.noOfSharedUsers === 'number' ? story.noOfSharedUsers : 0)
		});

		if (openSharePanelText === locale.get('Not shared')) {
			openSharePanelText = locale.get('Share Story...');
		}

		$('#btnMyStoriesShare').find('span').text(openSharePanelText);
	}

})(window.Storyboard = (window.Storyboard || {}));